import logo from "./logo.svg";
import "./App.css";
import BetBuilder from "./components/BetBuilder";
function App() {
  return (
    <div>
      {/* <header className="App-header">NAvbar</header> */}
      {/* <section className="App-body">Body</section> */}
      <BetBuilder />
    </div>
  );
}

export default App;
